import React, {ReactElement} from 'react';
import { getAssetUrl } from '../../../../utils/getAssetUrl';
import RightArrow from '../../images/right-arrow.png';

const styles = require('./index.module.less');

type TGameItem = {
  src: string,
  link: string,
  title: string
}

const GameItem: React.FC<TGameItem> = ({src, link, title}): ReactElement => {
  return (
    <div className={styles.container}>
      <div className={styles.imageContainer}>
        <a href={link} target={'_blank'}>
          <img src={src} />
        </a>
      </div>
      <div className={styles.titleContainer}>
        <div style={{marginTop: '8px', marginLeft: '5px'}}>{title}</div>
        <a href={link} className={styles.linkContainer} target={'_blank'}>
          <span className={styles.linkText}>前往万宝楼</span>
          <img className={styles.arrow} src={getAssetUrl(RightArrow.src)} />
        </a>
      </div>
    </div>
  )
}
export default GameItem;
